export const GlobalShortcuts = {
	NavigateToServices: 's+shift',
	NavigateToTraces: 't+shift',
	NavigateToLogs: 'l+shift',
	NavigateToDashboards: 'd+shift',
	NavigateToAlerts: 'a+shift',
	NavigateToExceptions: 'e+shift',
	NavigateToMessagingQueues: 'm+shift',
	ToggleSidebar: 'b+shift',
	NavigateToHome: 'h+shift',
};

export const GlobalShortcutsName = {
	NavigateToServices: 'shift+s',
	NavigateToTraces: 'shift+t',
	NavigateToLogs: 'shift+l',
	NavigateToDashboards: 'shift+d',
	NavigateToAlerts: 'shift+a',
	NavigateToExceptions: 'shift+e',
	NavigateToMessagingQueues: 'shift+m',
	ToggleSidebar: 'shift+b',
	NavigateToHome: 'shift+h',
};

export const GlobalShortcutsDescription = {
	NavigateToHome: 'Navigate to Home',
	NavigateToServices: 'Navigate to Services page',
	NavigateToTraces: 'Navigate to Traces Explorer',
	NavigateToLogs: 'Navigate to Logs Explorer',
	NavigateToDashboards: 'Navigate to Dashboards List',
	NavigateToAlerts: 'Navigate to Alerts List',
	NavigateToExceptions: 'Navigate to Exceptions List',
	NavigateToMessagingQueues: 'Navigate to Messaging Queues',
	ToggleSidebar: 'Toggle sidebar visibility',
};
